import React, { useState } from 'react';
import styles from './style.module.scss';
import {
  Card,
  Container,
  Button,
  TextField,
  InputAdornment,
  FormControl,
  DialogTitle,
  DialogContent,
  Dialog,
  Grid,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import { handleTypeNumber, CapitalizeFirstLetter } from '../../utils/utils';
import { moengageTrackEvent } from '../../Analytics/moengageEventFunction';
import colors from '../../theme/colors';
import { Popover } from 'react-bootstrap';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/scss/alice-carousel.scss';
import ImagePreviewComponent from '../../components/ImagePreviewComponent';
import { arzoooS3Url } from '../../utils/checkMode';

const useStyles = makeStyles({
  root: {
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      borderColor: '#e9ecef',
      borderRadius: '15px',
      boxShadow: 'rgb(17 17 26 / 5%) 0px 1px 0px, rgb(17 17 26 / 10%) 0px 0px 8px',
    },
    '& .MuiOutlinedInput-adornedStart': {
      paddingLeft: '25px',
    },
    '& .MuiInputAdornment-positionStart': {
      marginRight: '18px',
    },
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: '25px',
    },
    '& .MuiInputBase-input': {
      color: colors.themeLightBlue,
    },
  },
  inputField: {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#e9ecef',
      borderRadius: '10px',
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: colors.themeLightBlue,
    },
    '& .MuiFormLabel-root.Mui-focused': {
      color: colors.themeLightBlue,
    },
    '& .MuiInputBase-input': {
      color: colors.themeLightBlue,
    },
  },
  paper: {
    height: 'calc(100vh - 100px)',
    width: 'calc(100% - 300px)',
    borderRadius: '30px',
    '& .parentInput': {
      padding: '10px 120px',
    },
  },
  select: {
    '&:focus': {
      backgroundColor: 'white',
    },
  },
});

const CatalogueComponent = (props) => {
  const classes = useStyles();
  const [errorMsg, setErrorMsg] = useState({
    quantity: null,
    price: null,
    category: null,
    brand: null,
    model: null,
  });

  const [imagePreviewShown, setImagePreviewShown] = useState(false);
  const [previewedImages, setPreviewedImages] = useState([]);

  const recentSearchedCatalogueItems = localStorage.getItem('recentSearchedCatalogueItems')
    ? JSON.parse(localStorage.getItem('recentSearchedCatalogueItems'))
    : [];

  const previewImageTooltip = localStorage.getItem('previewImageTooltipDisabled');

  const [tooltipShown, setTooltipShown] = useState(!previewImageTooltip);

  //function to check validations
  const checkFieldsValidation = (e) => {
    if (e.target.name === 'model' || e.target.name === 'category' || e.target.name === 'brand') {
      if (!e.target.value)
        setErrorMsg({
          ...errorMsg,
          [e.target.name]: `${CapitalizeFirstLetter(e.target.name)} is required.`,
        });
    } else if (
      (e.target.name === 'price' && !e.target.value) ||
      (e.target.name === 'quantity' && !e.target.value)
    ) {
      setErrorMsg({
        ...errorMsg,
        [e.target.name]: `${CapitalizeFirstLetter(e.target.name)} is required.`,
      });
      return true;
    } else if (
      props.addProductObj.type !== 'new' &&
      parseInt(props.addProductObj.price) > props.addProductObj.mrp
    ) {
      setErrorMsg({
        ...errorMsg,
        price: `Listing price should not be greater than MRP(${props.addProductObj.mrp})`,
      });
      return true;
    }
  };

  //function to check form validation
  const checkFormValidation = () => {
    if (props.addProductObj.type === 'new') {
      if (
        errorMsg.model ||
        !props.addProductObj.model ||
        errorMsg.category ||
        !props.addProductObj.category ||
        errorMsg.brand ||
        !props.addProductObj.brand ||
        errorMsg.quantity ||
        !props.addProductObj.quantity ||
        errorMsg.price ||
        !props.addProductObj.price
      ) {
        return false;
      } else return true;
    } else {
      if (
        errorMsg.model ||
        !props.addProductObj.model ||
        errorMsg.quantity ||
        !props.addProductObj.quantity ||
        errorMsg.price ||
        !props.addProductObj.price
      ) {
        return false;
      } else return true;
    }
  };

  //function to set error msg to false
  const clearErrorMsg = () => {
    setErrorMsg({ quantity: null, price: null, category: null, brand: null, model: null });
  };

  //function to set specific field of error to null
  const handleError = (e) => {
    setErrorMsg({ ...errorMsg, [e.target.name]: false });
  };

  const handleImageClick = (list) => {
    setImagePreviewShown(true);
    setPreviewedImages(list || []);
  };

  const handlePreviewClose = () => {
    setImagePreviewShown(false);
    setPreviewedImages([]);
  };

  const handleDragStart = (e) => e.preventDefault();

  const showProductItems = () => {
    const condition =
      (props.modelArray && props.modelArray.length > 0) ||
      (recentSearchedCatalogueItems.length > 0 && !props.showModelDetails && !props.showAddNewBtn);

    return condition;
  };

  const recentSearchCondition = () => {
    const condition =
      !!recentSearchedCatalogueItems.length &&
      !(props.modelArray || []).length &&
      !props.showModelDetails &&
      !props.showAddNewBtn;

    return condition;
  };

  return (
    <div>
      <Dialog
        classes={{ paper: classes.paper }}
        maxWidth="xl"
        open={props.show}
        onClose={() => props.handleClose()}
      >
        <ImagePreviewComponent
          open={imagePreviewShown && !!previewedImages.length}
          onClose={handlePreviewClose}
          images={previewedImages || []}
          imageBaseUrl={`${arzoooS3Url}/images/products/`}
          onDragStart={handleDragStart}
        />

        <DialogTitle
          id="customized-dialog-title"
          onClose={() => props.handleClose()}
          className={styles.modalTitle}
        >
          <div className="d-flex justify-content-end align-items-center">
            <IconButton className={styles.closeBtn} onClick={() => props.handleClose()}>
              <CloseIcon className={styles.searchClose} />
            </IconButton>
          </div>
          <div className="d-flex font-weight-bold justify-content-center align-items-center">
            ADD NEW PRODUCT
          </div>
        </DialogTitle>
        <DialogContent className="m-2">
          <Container maxWidth="md">
            <div className="d-flex text-center p-0 flex-column">
              <span>Search products to add them into your inventory.</span>
              <span className={styles.warning_msg}>* Enter minimum 3 characters to search</span>
            </div>
            <FormControl className="parentInput" fullWidth variant="outlined">
              <TextField
                id="outlined-basic"
                autoComplete="off"
                placeholder="Search by model"
                variant="outlined"
                autoFocus="true"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon style={{ color: 'grey' }} />
                    </InputAdornment>
                  ),
                  endAdornment: props.searchedModelId ? (
                    <InputAdornment position="end">
                      <IconButton
                        className={styles.closeBtn}
                        onClick={() => props.clearSearchResult()}
                      >
                        {' '}
                        <CloseIcon className={styles.searchClose} />
                      </IconButton>
                    </InputAdornment>
                  ) : null,
                }}
                className={classes.root}
                value={props.searchedModelId}
                onChange={(e) => props.searchModelIdFnc(e)}
              />
            </FormControl>
            {recentSearchCondition() && (
              <div className={styles.recentSearch}>
                <img src="/images/recentSearch.svg" />
                <span>Recent Search</span>
              </div>
            )}
            {showProductItems() && (
              <Paper elevation={0} className={styles.autoSearchInput}>
                {(props.modelArray || recentSearchedCatalogueItems.reverse()).map((item, index) => {
                  return (
                    <div key={index} className={styles.searchItem}>
                      {item.images_json?.primaryImage ? (
                        <img
                          className={styles.imgStyle}
                          alt="Product Image"
                          src={item.images_json.primaryImage}
                          // src={`${arzoooS3Url}/images/products/${
                          //   // item.img_hash_list[item.primary_img]
                          //   item.images_json.imagesData.primaryImage
                          // }`}
                        />
                      ) : (
                        <span className={styles.imgPlaceHolder}>Image Not Found!</span>
                      )}
                      <div className={styles.searchItemNameContainer}>
                        <span className={styles.itemModalId}>Model ID: {item.model_name}</span>
                        <span className={styles.itemName}>{item.display_name}</span>
                      </div>
                      <button
                        onClick={() => {
                          props.selectedModelFnc(item.model_name, 'exsisting', item);
                          clearErrorMsg();
                        }}
                        className={`${styles.addButton}`}
                      >
                        <span>ADD</span>
                      </button>
                    </div>
                  );
                })}
              </Paper>
            )}
            {props.modelArray && props.modelArray.length === 0 && (
              <Paper elevation={1} className={styles.autoSearchInput}>
                {props.modelArray && props.modelArray.length === 0 && (
                  <div className={styles.noData}>No products found</div>
                )}
              </Paper>
            )}
            {props.showAddNewBtn ? (
              <div className={`${styles.noResult} text-muted text-center`}>
                Looks like the product you wish to add is not in our catalogue yet. Raise a request
                for adding new catalogue for this product.
                <br />
                <Button
                  variant="outlined"
                  color="primary"
                  className="mt-2"
                  onClick={() =>
                    props.addProductObj.type !== 'new' ? props.selectedModelFnc(null, 'new') : null
                  }
                  moenagage-id={JSON.stringify({
                    eventName: 'Product_New Request_Initited',
                    eventSource: 'From the add product modal',
                  })}
                >
                  {' '}
                  Raise catalogue request
                </Button>
              </div>
            ) : null}
            {props.showModelDetails ? (
              <Card className={styles.autoModalCard} variant="outlined">
                {props.addProductObj.type === 'new' ? (
                  <div className={styles.catTitle}>
                    Fill the details below to request a new catalogue creation.
                  </div>
                ) : (
                  <></>
                )}
                <Grid container spacing={5}>
                  <Grid item xs={12}>
                    {props.addProductObj.type == 'new' ? (
                      <FormControl variant="outlined" className="mb-2" fullWidth>
                        <TextField
                          id="outlined-basic"
                          variant="outlined"
                          autoComplete="off"
                          label={
                            props.addProductObj.type !== 'new' ? 'Selected Model' : 'Enter Model'
                          }
                          name="model"
                          disabled={props.addProductObj.type === 'exsisting'}
                          error={errorMsg.model ? true : false}
                          helperText={errorMsg.model}
                          value={
                            props.addProductObj.pack_quantity && props.addProductObj.model
                              ? `${props.addProductObj.model} ( Pack Quantity - ${props.addProductObj.pack_quantity} )`
                              : props.addProductObj.model || ''
                          }
                          onChange={(e) => {
                            props.productObj(e);
                            handleError(e);
                          }}
                          onBlur={(e) => checkFieldsValidation(e)}
                          className={classes.inputField}
                        />
                      </FormControl>
                    ) : (
                      <div className={styles.productDetailContainer}>
                        {(props.addProductObj?.img_hash_list || []).length > 0 &&
                        props.addProductObj.img_hash_list[props.addProductObj.primary_img] &&
                        props.addProductObj.img_hash_list[props.addProductObj.primary_img] !==
                          '' ? (
                          <>
                            <img
                              className={`${styles.largeImgStyle} ${styles.cursorP}`}
                              onClick={() => {
                                handleImageClick(props.addProductObj.img_hash_list);
                              }}
                              alt="Product Image"
                              src={`${arzoooS3Url}/images/products/${
                                props.addProductObj.img_hash_list[props.addProductObj.primary_img]
                              }`}
                            />
                            {!previewImageTooltip && tooltipShown && (
                              <Popover
                                id={`ppopover-${props?.addProductObj?.productId}`}
                                className={`${styles.previewImageTooltip}`}
                              >
                                <Popover.Content>
                                  <div className="d-flex justify-content-between align-items-start">
                                    <span>Click here to enlarger product image</span>
                                    <img
                                      className={`mt-1 ${styles.cursorP}`}
                                      src="/images/cancel.svg"
                                      onClick={() => {
                                        setTooltipShown(false);
                                        localStorage.setItem('previewImageTooltipDisabled', true);
                                      }}
                                    />
                                  </div>
                                </Popover.Content>
                              </Popover>
                            )}
                          </>
                        ) : (
                          <span className={styles.largeImgPlaceHolder}>Image Not Found!</span>
                        )}
                        <div className={styles.searchItemNameContainer}>
                          <span className={styles.itemModalId}>
                            Model ID: {props.addProductObj?.model || '-'}
                          </span>
                          <span className={styles.itemName}>
                            {props.addProductObj?.display_name || '-'}
                          </span>
                          {props.addProductObj?.brand && (
                            <span className={styles.brandName}>
                              by {props.addProductObj?.brand}
                            </span>
                          )}
                        </div>
                      </div>
                    )}
                  </Grid>
                  {props.addProductObj.type === 'new' ? (
                    <React.Fragment>
                      <Grid item md={6}>
                        <FormControl
                          style={{ width: '100%' }}
                          required
                          error={errorMsg.category ? true : false}
                        >
                          <InputLabel id="demo-simple-select-label">Select Category</InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={props.addProductObj.category || ''}
                            onChange={(e) => {
                              props.productObj(e);
                            }}
                            onBlur={(e) => checkFieldsValidation(e)}
                            variant="standard"
                            name="category"
                            fullWidth
                            helperText={errorMsg.category}
                            inputProps={{
                              classes: { select: classes.select },
                            }}
                            onClose={() => {
                              setTimeout(() => {
                                document.activeElement.blur();
                              }, 0);
                            }}
                          >
                            {props.category.map((cat, index) => {
                              return (
                                <MenuItem key={index} value={cat}>
                                  {cat}
                                </MenuItem>
                              );
                            })}
                          </Select>
                          <FormHelperText>{errorMsg.category}</FormHelperText>
                        </FormControl>
                      </Grid>
                      <Grid item md={6}>
                        <FormControl variant="outlined" className="mb-2" fullWidth>
                          <TextField
                            id="outlined-basic"
                            variant="outlined"
                            type="text"
                            autoComplete="off"
                            label="Enter Brand"
                            name="brand"
                            error={errorMsg.brand ? true : false}
                            helperText={errorMsg.brand}
                            value={props.addProductObj.brand || ''}
                            onChange={(e) => {
                              props.productObj(e);
                              handleError(e);
                            }}
                            onBlur={(e) => checkFieldsValidation(e)}
                            className={classes.inputField}
                          />
                        </FormControl>
                      </Grid>
                    </React.Fragment>
                  ) : null}
                  <Grid item md={6}>
                    <FormControl variant="outlined" className="mb-2" fullWidth>
                      <TextField
                        id="outlined-basic"
                        variant="outlined"
                        type="number"
                        autoComplete="off"
                        onKeyDown={(evt) => handleTypeNumber(evt)}
                        label="Enter Available Quantity"
                        name="quantity"
                        error={errorMsg.quantity ? true : false}
                        helperText={errorMsg.quantity}
                        value={props.addProductObj.quantity || ''}
                        onChange={(e) => {
                          props.productObj(e);
                          handleError(e);
                        }}
                        onBlur={(e) => checkFieldsValidation(e)}
                        className={classes.inputField}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item md={6}>
                    <FormControl variant="outlined" className="mb-2" fullWidth>
                      <TextField
                        id="outlined-basic"
                        variant="outlined"
                        type="number"
                        autoComplete="off"
                        onKeyDown={(evt) => handleTypeNumber(evt)}
                        // label={`Enter Price ${
                        //   props.addProductObj?.suggested_price
                        //     ? `(Suggested Price: ₹${props.addProductObj?.suggested_price})`
                        //     : ''
                        // }`}
                        label={`Enter Price`}
                        name="price"
                        error={errorMsg.price ? true : false}
                        helperText={errorMsg.price}
                        value={props.addProductObj.price || ''}
                        onChange={(e) => {
                          props.productObj(e);
                          handleError(e);
                        }}
                        onBlur={(e) => checkFieldsValidation(e)}
                        className={classes.inputField}
                      />
                      {props.addProductObj?.suggested_price && (
                        <span className={`${styles.suggestedPrice}`}>
                          Suggested Price: ₹{props.addProductObj?.suggested_price}
                        </span>
                      )}
                    </FormControl>
                  </Grid>
                  {props.addProductObj.type == 'new' && (
                    <React.Fragment>
                      <Grid item md={6}>
                        <FormControl variant="outlined" className="mb-2" fullWidth>
                          <TextField
                            id="outlined-basic"
                            variant="outlined"
                            autoComplete="off"
                            label={
                              props.addProductObj.type !== 'new'
                                ? 'Product link'
                                : 'Enter Product link'
                            }
                            name="link"
                            disabled={props.addProductObj.type === 'exsisting'}
                            error={errorMsg.link ? true : false}
                            helperText={errorMsg.link}
                            value={props.addProductObj.link || ''}
                            onChange={(e) => {
                              props.productObj(e);
                              handleError(e);
                            }}
                            onBlur={(e) => checkFieldsValidation(e)}
                            className={classes.inputField}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item md={6}>
                        <FormControl variant="outlined" className="mb-2" fullWidth>
                          <TextField
                            id="buf"
                            type="file"
                            variant="outlined"
                            name="files"
                            inputProps={{ accept: '.png,.jpg,.jpeg,.gif' }}
                            label={'Upload Product Image'}
                            custom
                            onChange={(e) => {
                              props.productObj(e);
                              // setfile(e.target.files);
                            }}
                            InputLabelProps={{ shrink: true }}
                            style={{ float: 'left' }}
                            className={classes.inputField}
                          ></TextField>
                        </FormControl>
                      </Grid>
                    </React.Fragment>
                  )}
                </Grid>
              </Card>
            ) : null}
            {props.showModelDetails && (
              <Grid item className="d-flex align-items-center justify-content-center">
                <Button
                  variant="contained"
                  color="primary"
                  className={!checkFormValidation() ? styles.disableBtn : null}
                  disabled={!checkFormValidation()}
                  onClick={() => {
                    moengageTrackEvent('Add_Product_confirmed', {
                      params: JSON.stringify(props.addProductObj),
                    });
                    props.addInv();
                  }}
                >
                  {props.addProductObj.type === 'new' ? 'Send request' : 'Add Product'}
                </Button>
              </Grid>
            )}
          </Container>
        </DialogContent>
      </Dialog>
    </div>
  );
};

const AddCatalogueComponent = React.memo(CatalogueComponent);
export default AddCatalogueComponent;
